import * as Cookie from './cookie';

export default function initTopics() {
    const orderTopicsDropdown = document.querySelector('[data-select-topic-order]');
    const orderTopicsButtons = document.querySelector('[data-select-topic-button]');

    // Click event for expanding comment panels
    document.querySelectorAll('[data-expand-comments]').forEach((el) => el.addEventListener('click', (event) => {
        event.preventDefault();

        const topicsCommentsWrapper = el.closest('.topic-comments-wrapper');
        topicsCommentsWrapper.classList.toggle('expand');
        topicsCommentsWrapper.querySelector('.topic-comments').classList.toggle('hidden');

        if (topicsCommentsWrapper.getAttribute('aria-expanded') === 'false') {
            topicsCommentsWrapper.setAttribute('aria-expanded', 'true');
        } else {
            topicsCommentsWrapper.setAttribute('aria-expanded', 'false');
        }
    }));

    // Click event for opening comment form popup for a topic
    document.querySelectorAll('[data-open-comment-form]').forEach((el) => el.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const topicWrapperId = el.closest('.topic').getAttribute('data-topic-id');

        if (topicWrapperId) {
            const commentFormPopup = document.querySelector(`#topic-comments-wrapper-${topicWrapperId} .comment-form-popup-wrapper`);
            commentFormPopup.classList.remove('hidden');
            commentFormPopup.setAttribute('aria-expanded', 'true');
        }
    }));

    // Click event for closing a comment form popup for a topic
    document.querySelectorAll('[data-close-comment-form]').forEach((el) => el.addEventListener('click', (event) => {
        event.preventDefault();
        el.parentNode.classList.toggle('hidden');
        el.parentNode.setAttribute('aria-expanded', 'false');
    }));

    // Click events for voting on a topic (+1 or -1)
    document.querySelectorAll('[data-vote-up]').forEach((el) => el.addEventListener('click', (event) => {
        event.preventDefault();

        const topicWrapperId = el.closest('.topic').getAttribute('data-topic-id');

        setVote(topicWrapperId, 'up');
    }));

    document.querySelectorAll('[data-vote-down]').forEach((el) => el.addEventListener('click', (event) => {
        event.preventDefault();

        const topicWrapperId = el.closest('.topic').getAttribute('data-topic-id');

        setVote(topicWrapperId, 'down');
    }));

    // Change order of topics
    if (orderTopicsButtons) {
        orderTopicsButtons.addEventListener('click', (event) => {
            Cookie.set('topics-order', orderTopicsDropdown.value, 31536000);

            window.location.reload();
        });
    }
}

export function setVote(topicId, type) {
    const cookieName = 'topic-votes';
    let cookieValue = Cookie.get(cookieName);

    if (!Cookie.has(cookieName) || cookieValue.indexOf(`topic-${topicId}||${type}`) == -1) {
        if (!Cookie.has(cookieName)) {
            Cookie.set(cookieName, `topic-${topicId}||${type}`, 31536000);
        } else {
            // Remove vote from cookie when previous vote exists and is from a different type
            if (type == 'up' && cookieValue.indexOf(`topic-${topicId}||down`) != -1) {
                cookieValue = cookieValue.replace(`topic-${topicId}||down`, '');
                sendVote(topicId, 'down', 'minus');
            }

            if (type == 'down' && cookieValue.indexOf(`topic-${topicId}||up`) != -1) {
                cookieValue = cookieValue.replace(`topic-${topicId}||up`, '');
                sendVote(topicId, 'up', 'minus');
            }

            // When topic-votes cookie was not empty, add the topicId and type of vote to the end of the string
            const topicVotes = `${cookieValue}||topic-${topicId}||${type}`;
            Cookie.set(cookieName, topicVotes, 20160);
        }

        sendVote(topicId, type);
    }
}

export function sendVote(topicId, type, modus = 'plus') {
    const Request = new XMLHttpRequest();
    Request.open('POST', '/vote');
    Request.setRequestHeader('Accept', 'application/json');

    const formData = new FormData();
    formData.append('topic_id', topicId);
    formData.append('vote_type', type);
    formData.append('modus', modus);

    let called = false;
    Request.onreadystatechange = () => {
        if (Request.readyState === XMLHttpRequest.DONE && !called) {
            if (Request.status == 200 && modus === 'plus') {
                window.location.reload();
            }

            called = true;
        }
    };

    Request.send(formData);
}
